/**
 * Checks if the given value is a non-empty object.
 *
 * @param {any} obj - The value to be checked.
 * @returns {boolean} True if the value is a non-empty object, otherwise false.
 */
// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export function isNotEmptyObject(obj: any) : boolean {
  return obj && typeof obj === 'object' && !Array.isArray(obj) && Object.keys(obj).length > 0;
}
